import { Outlet } from 'react-router'

import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Toolbar from '@mui/material/Toolbar'

import Header from './Header'
import Sidebar from './Sidebar'

export default function Layout() {
  return (
    <Box sx={styles.root}>
      <Sidebar />
      <Box sx={styles.main}>
        <Header />
        <Toolbar />
        <Container sx={styles.container}>
          <Outlet />
        </Container>
      </Box>
    </Box>
  )
}

const styles = {
  root: {
    display: 'flex',
    width: '100%',
    minHeight: '100vh',
  },
  main: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
  },
  container: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },
}
